import React from 'react'
import { useSelector } from 'react-redux'
import { selectUserPermissionCodes } from 'state/profile'
import Context from './PermissionsContext'

const PermissionProvider: React.FC = ({ children }) => {
    const userPermissionCodes = useSelector(selectUserPermissionCodes)
    const isAllowedTo = (toCheckPermissions: string[]) => {
        const userPermissionsAccess: { [key: string]: boolean } = {}
        toCheckPermissions.forEach((permission: string) => {
            userPermissionsAccess[permission] = userPermissionCodes.has(permission)
        })
        return userPermissionsAccess
    }
    return <Context.Provider value={{ isAllowedTo: isAllowedTo }}>{children}</Context.Provider>
}

export default PermissionProvider
